import Vue from '../node_modules/vue/dist/vue.common';
import ATDSuperTable from './lib/AtdSuperTable.js';

Vue.config.devtools = true

let DocumentSearch = function(elId) {
    if(!document.getElementById(elId)) {
        return null;
    }

    return new Vue({
        el: `#${elId}`,
        data: {
            documents: [],
            is_mounted: false,
            currentSort:'title',
            currentSortDir:'asc',
            search: {
                keyword: '',
                document_type: '',
                audience: '',
                publication_date : '',
                file_format: '',
                results_per_page: 10,
                page: 1,
                document_count: 0,
            },
            is_results_fading: false,
            is_fading: false,
            is_loading: false
        },
        computed: {
            page_count: function() {
                return  Math.ceil(this.documents.length / this.search.results_per_page);
            },
            visible_results: function() {
                let start  = this.search.results_per_page * (this.search.page - 1)
                let end = start + this.search.results_per_page;
                // return this.documents.slice(start, end);
                return this.documents.sort((a,b) => {
                    let modifier = 1;
                    if(this.currentSortDir === 'desc') modifier = -1;
                    if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                  }).slice(start, end);
            },
            // sortedDocuments:function() {
            //     return this.visible_results.sort((a,b) => {
            //       let modifier = 1;
            //       if(this.currentSortDir === 'desc') modifier = -1;
            //       if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
            //       if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
            //       return 0;
            //     });
            // },
        },
        mounted: function() {
            this.is_mounted = true;

            this.handlePopState(false);

            window.onpopstate = () => {
                this.handlePopState(true);
            }
        },
        methods: {
            handlePopState(is_popstate) {
                /* check url params for search terms */
                let url_params = new URLSearchParams(window.location.search);
                let should_search = false;
                
                if(url_params.has('keyword')) {
                    this.search.keyword = url_params.get('keyword');
                    should_search = true;
                } else if (is_popstate) {
                    this.search.keyword = '';
                }

                if(url_params.has('type')) {
                    this.search.document_type = url_params.get('type');
                    should_search = true;
                } else if (is_popstate) {
                    this.search.document_type = '';
                }

                if(url_params.has('audience')) {
                    this.search.audience = url_params.get('audience');
                    should_search = true;
                } else if (is_popstate) {
                    this.search.audience = '';
                }

                if(url_params.has('year')) {
                    this.search.publication_date = url_params.get('year');
                    should_search = true;
                } else if (is_popstate) {
                    this.search.publication_date = '';
                }

                if(url_params.has('format')) {
                    this.search.file_format = url_params.get('format');
                    should_search = true;
                } else if (is_popstate) {
                    this.search.file_format = '';
                }

                if(should_search || is_popstate) {
                    this.is_loading = true;

                    window.setTimeout(() => {
                        window.scrollTo(0, 0);
                        this.getdocuments().then(response => {
                            this.documents = response;
                            this.search.current_page = 1;
                            this.detail = null;
                            this.is_loading = false;
                        });
                    }, 500);
                }
            },

            onSearch(e) {
                e && e.preventDefault();

                this.is_loading = true;

                this.setURLSearchParams();

                window.setTimeout(() => {
                    window.scrollTo(0, 0);
                    this.getdocuments().then(response => {
                        this.documents = response;
                        this.search.current_page = 1;
                        this.detail = null;
                        this.is_loading = false;

                        if(e || !this.search.page) {
                            this.search.page = 1;
                        }
                    });
                }, 500);
            },

            sort:function(s) {
                //if s == current sort, reverse
                if(s === this.currentSort) {
                  this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
                }
                this.currentSort = s;
                this.search.page = 1;
            },

            onChangePage(e, page) {
                console.log(page);
                e && e.preventDefault();
 
                if(page > 0 && page <= this.page_count && page !== this.search.page) {
                    console.log('page');

                    this.is_results_fading = true;
 
                    window.setTimeout(() => {
                        let results_offset = document.getElementById('results').offsetTop;
                        window.scrollTo(0, results_offset);
                        this.search.page = page;
                        window.history.pushState({search: Object.assign({}, this.search, {page: page})}, `Document Search Results - Page ${page} of ${this.page_count}`, this.setURLSearchParams());
                        this.is_results_fading = false;
                    }, 300);
                 }
            },

           setURLSearchParams() {
               let param_string = window.location.origin + window.location.pathname + '?';
            
                if(this.search.keyword) {
                    param_string += 'keyword=' + this.search.keyword + '&';
                }

                if(this.search.document_type) {
                    param_string += 'type=' + this.search.document_type + '&';
                }

                if(this.search.audience) {
                    param_string += 'audience=' + this.search.audience + '&';
                }

                if(this.search.publication_date) {
                    param_string += 'year=' + this.search.publication_date + '&';
                }

                if(this.search.file_format) {
                    param_string += 'format=' + this.search.file_format + '&';
                }

                window.history.pushState(null, null, param_string.slice(0, -1))
           },

           getdocuments() {
                return fetch(`/wp-json/atd/documents/search/?keyword=${this.search.keyword}&document_type=${this.search.document_type}&audience=${this.search.audience}&publication_date=${this.search.publication_date}&file_format=${this.search.file_format}`, {
                    method: 'GET'
                })
                .then(response => response.json());
            }
        }
    });
};

let db = new DocumentSearch('document-search');


// WEBPACK FOOTER //
// ./js/document-search.js